
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(isB2B, badge, badgeIndex) {
                    return _createElement('div', {
                        'className': 'product-label-wrapper flex',
                        'key': badge
                    }, _createElement('span', { 'className': 'product-label product-label--custom cm_badge cm_badge__' + this.toKebabCase(badge) }, '\n            ', badge, '\n          '));
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function scopeDefaultTaxRateDisplayPriceDisplayMinPriceDisplayCompareAtPrice3(isB2B) {
                    var defaultTaxRate = 1.23;
                    var displayPrice = isB2B ? this.price / defaultTaxRate : this.price;
                    var displayMinPrice = isB2B ? (this.min_price || this.price) / defaultTaxRate : this.min_price || this.price;
                    var displayCompareAtPrice = isB2B && this.compare_at_price ? this.compare_at_price / defaultTaxRate : this.compare_at_price;
                    return _createElement('div', { 'className': 'price' }, _createElement('div', { 'className': 'price__default' }, this.price_varies ? _createElement('span', { 'key': '4679' }, _translate(`price_from`), ' ') : null, _createElement('strong', { 'className': 'price__current' }, this.formatPrice(displayMinPrice)), this.on_sale ? _createElement('s', {
                        'className': 'price__was',
                        'key': '4851'
                    }, this.formatPrice(displayCompareAtPrice)) : null, this.set_qty && !this.price_varies ? _createElement('div', {
                        'className': 'price-item--set',
                        'key': '4954'
                    }, '\n                ', _translate(`product_set_of`, {  count: this.set_qty  }), ': ', this.formatPrice(displayPrice * this.set_qty), '\n              ') : null), !isB2B ? _createElement('span', {
                        'className': 'js-value_preprice',
                        'key': '5209'
                    }, _translate(`product_vat_included`)) : null, isB2B ? _createElement('span', {
                        'className': 'js-value_preprice',
                        'key': '5313'
                    }, _translate(`product_price_excluding_vat`)) : null);
                }
                function scopeIsB2BDisplayPrice4(isB2B) {
                    var isB2B = !!(window.Convermax.Shopify && window.Convermax.Shopify.getCompanyLocationId());
                    var displayPrice = isB2B ? this.price / 1.23 : this.price;
                    return _createElement('p', {
                        'className': 'affirm-as-low-as',
                        'data-amount': displayPrice * 100,
                        'data-affirm-type': 'logo',
                        'data-affirm-color': 'blue',
                        'key': '9231'
                    });
                }
                function scopeIsB2B5() {
                    var isB2B = !!(window.Convermax.Shopify && window.Convermax.Shopify.getCompanyLocationId());
                    return _createElement('li', {}, _createElement('product-card', { 'class': 'card card--product h-full card--product-contained card--no-lines relative flex' + (this.is_promotional_item ? ' cm_promotion' : '') }, _createElement('div', { 'className': 'card__media relative' }, _createElement('a', {
                        'href': this.url,
                        'aria-label': this.removeHTML(this.title),
                        'className': 'media block relative image-blend js-prod-link',
                        'tabIndex': '-1'
                    }, _createElement('img', {
                        'className': 'img-fit card__main-image no-js-hidden',
                        'src': this.imageOrDefault(this.resizeImage(this.image)),
                        'data-media-id': this.id,
                        'loading': 'lazy',
                        'alt': this.removeHTML(this.title),
                        'onError': this.onImageError
                    })), _createElement('div', { 'className': 'product-label-container absolute top-0 end' }, this.Notes || this.Position ? _createElement('div', {
                        'className': 'product-label-wrapper flex flex-col flex-wrap gap-3',
                        'key': '773'
                    }, this.Notes ? _createElement('span', {
                        'className': 'product-label product-label--custom product-label--notes',
                        'key': '885'
                    }, this.Notes.join(', ')) : null, this.Position ? _createElement('span', {
                        'className': 'product-label product-label--custom product-label--position',
                        'key': '1026'
                    }, this.Position.join(', ')) : null) : null), _createElement.apply(this, [
                        'div',
                        { 'className': 'product-label-container absolute bottom-0 start' },
                        this.out_of_stock ? _createElement('div', {
                            'className': 'product-label-wrapper flex',
                            'key': '1270'
                        }, _createElement('span', { 'className': 'product-label product-label--sold-out' }, _translate(`product_out_of_stock`))) : null,
                        this.on_sale ? _createElement('div', {
                            'className': 'product-label-wrapper flex',
                            'key': '1467'
                        }, _createElement('span', { 'className': 'product-label product-label--sale' }, _createElement('svg', {
                            'className': 'icon icon--price_tag',
                            'width': '14',
                            'height': '14',
                            'viewBox': '0 0 16 16',
                            'aria-hidden': 'true',
                            'focusable': 'false',
                            'role': 'presentation'
                        }, _createElement('path', {
                            'fill': 'currentColor',
                            'd': 'M7.59 1.34a1 1 0 01.7-.29h5.66a1 1 0 011 1v5.66a1 1 0 01-.3.7L7.6 15.5a1 1 0 01-1.42 0L.52 9.83a1 1 0 010-1.42l7.07-7.07zm6.36 6.37l-7.07 7.07-5.66-5.66L8.3 2.05h5.66v5.66z',
                            'fillRule': 'evenodd'
                        }), _createElement('path', {
                            'fill': 'currentColor',
                            'd': 'M9.7 6.3a1 1 0 101.42-1.42 1 1 0 00-1.41 1.41zM9 7a2 2 0 102.83-2.83A2 2 0 009 7z',
                            'fillRule': 'evenodd'
                        })), '\n            ', _translate(`product_discount`, {  discount: Math.round(Number(((1 - this.price / this.compare_at_price) * 100).toFixed(10)))  }), '\n          ')) : null,
                        this._badges ? _map(this._badges, repeatBadge1.bind(this, isB2B)) : null
                    ])), _createElement('div', { 'className': 'card__info-container flex flex-col flex-auto relative' }, _createElement('div', { 'className': 'card__info w-full' }, _createElement('div', { 'className': 'card__info-inner inline-block w-full' }, this.vendor ? _createElement('p', mergeProps({
                        'className': 'card__vendor mb-0 text-sm text-theme-light',
                        'key': '2796'
                    }, { dangerouslySetInnerHTML: { __html: typeof this.vendor === 'undefined' ? '' : this.vendor } })) : null, _createElement('p', { 'className': 'card__title font-bold mb-1' }, _createElement('a', mergeProps({
                        'href': this.url,
                        'className': 'card-link text-current js-prod-link'
                    }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } }))), this.tracks_inventory && this.is_low_stock && !this.out_of_stock ? _createElement('div', {
                        'className': 'pt-2 text-xs product-inventory__status product-inventory__status--very-low',
                        'key': '3277'
                    }, '\n            ', _translate(`stock_very_low`), '\n          ') : null, this.tracks_inventory && !this.is_low_stock && !this.is_backordered && !this.out_of_stock ? _createElement('div', {
                        'className': 'pt-2 text-xs product-inventory__status product-inventory__status--normal',
                        'key': '3526'
                    }, '\n            ', _translate(`stock_in_stock`), '\n          ') : null, this.tracks_inventory && this.is_backordered ? _createElement('div', {
                        'className': 'pt-2 text-xs product-inventory__status product-inventory__status--backordered',
                        'key': '3806'
                    }, '\n            ', _translate(`stock_backordered`), '\n          ') : null, scopeDefaultTaxRateDisplayPriceDisplayMinPriceDisplayCompareAtPrice3.apply(this, [isB2B]))), _createElement('div', { 'className': 'card__quick-add mob:card__quick-add--below desktop:card__quick-add--below' }, _createElement('convermax-product-form', {}, _createElement('form', {
                        'method': 'post',
                        'action': '/cart/add',
                        'id': 'quick-add-' + this.id,
                        'acceptCharset': 'UTF-8',
                        'className': 'js-product-form',
                        'encType': 'multipart/form-data',
                        'noValidate': 'novalidate'
                    }, _createElement('input', {
                        'type': 'hidden',
                        'name': 'form_type',
                        'value': 'product'
                    }), _createElement('input', {
                        'type': 'hidden',
                        'name': 'utf8',
                        'value': '\u2713'
                    }), _createElement('input', {
                        'type': 'hidden',
                        'name': 'product-id',
                        'value': this.id
                    }), _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.variant_ids[0]
                    }), this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                        'type': 'hidden',
                        'name': 'properties[Fitment]',
                        'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                        'key': '6048'
                    }) : null, this.out_of_stock ? _createElement('button', {
                        'className': 'cm_sold-out btn btn--primary w-full',
                        'name': 'add',
                        'disabled': true,
                        'key': '6260'
                    }, _createElement('span', { 'className': 'quick-add-btn-text' }, _translate(`product_out_of_stock`))) : null, !this.out_of_stock && this.variant_ids.length === 1 && (!this.ProductScope || this.ProductScope === 'child') ? _createElement('div', {
                        'className': 'cm_add-to-cart flex',
                        'key': '6488'
                    }, _createElement('div', { 'className': 'qty-input qty-input--combined inline-flex items-center' }, _createElement('button', {
                        'type': 'button',
                        'className': 'qty-input__btn btn btn--minus',
                        'name': 'minus',
                        'aria-label': _translate(`product_quantity_decrease`),
                        'onClick': e => e.currentTarget.nextElementSibling.stepDown()
                    }), _createElement('input', {
                        'type': 'number',
                        'className': 'qty-input__input input',
                        'name': 'quantity',
                        'min': '1',
                        'defaultValue': this.set_qty || 1,
                        'aria-label': _translate(`product_quantity_input`)
                    }), _createElement('button', {
                        'type': 'button',
                        'className': 'qty-input__btn btn btn--plus',
                        'name': 'plus',
                        'aria-label': _translate(`product_quantity_increase`),
                        'onClick': e => e.currentTarget.previousElementSibling.stepUp()
                    })), _createElement('button', {
                        'className': 'btn btn--primary flex-auto',
                        'name': 'add',
                        'aria-haspopup': 'dialog',
                        'aria-label': _translate(`product_add_to_cart`)
                    }, [_createElement('svg', {
                            'width': '24',
                            'height': '24',
                            'viewBox': '0 0 24 24',
                            'className': 'icon icon--cart',
                            'aria-hidden': 'true',
                            'focusable': 'false',
                            'role': 'presentation',
                            'key': '75390'
                        }, _createElement('path', {
                            'fill': 'currentColor',
                            'd': 'M17 18a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2M1 2h3.27l.94 2H20a1 1 0 0 1 1 1c0 .17-.05.34-.12.5l-3.58 6.47c-.34.61-1 1.03-1.75 1.03H8.1l-.9 1.63-.03.12a.25.25 0 0 0 .25.25H19v2H7a2 2 0 0 1-2-2c0-.35.09-.68.24-.96l1.36-2.45L3 4H1V2m6 16a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2m9-7 2.78-5H6.14l2.36 5H16Z'
                        }))]), _createElement('div', {
                        'className': 'cm_add-to-cart_error alert bg-error-bg text-error-text text-start',
                        'popover': 'manual',
                        'hidden': true
                    }, _createElement('div', {
                        'className': 'js-form-error',
                        'role': 'alert'
                    }), _createElement('button', {
                        'type': 'button',
                        'className': 'cm_add-to-cart_error-close',
                        'aria-label': _translate(`product_warning_close`)
                    }, [_createElement('svg', {
                            'viewBox': '0 0 24 24',
                            'fill': 'none',
                            'stroke': 'currentColor',
                            'stroke-width': '2',
                            'stroke-linecap': 'round',
                            'stroke-linejoin': 'round',
                            'aria-hidden': 'true',
                            'key': '84240'
                        }, _createElement('path', { 'd': 'M6 6l12 12M18 6L6 18' }))]))) : null)), !this.out_of_stock && this.variant_ids.length > 1 || this.ProductScope === 'master' ? _createElement('button', {
                        'type': 'button',
                        'className': 'btn btn--primary w-full js-quick-add',
                        'aria-haspopup': 'dialog',
                        'data-product-url': this.url,
                        'data-product-default-variant': 'false',
                        'data-quick-add-listener-added': 'true',
                        'key': '8761'
                    }, _createElement('span', { 'className': 'quick-add-btn-text block pointer-events-none' }, _translate(`product_select_options`))) : null)), this.price ? scopeIsB2BDisplayPrice4.apply(this, [isB2B]) : null));
                }
                return scopeIsB2B5.apply(this, []);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'h4 mt-10 cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'ul',
        { 'className': 'slider slider__grid grid grid-flow-col auto-cols-2 small-cards-mobile md:auto-cols-3 lg:auto-cols-4 xl:auto-cols-5 small-cards-desktop gap-x-theme gap-y-8 cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []